type PatientActionVisibilityOptions = {
  isPractitionerWorkspace: boolean;
  canAccessNursingActions: boolean;
  isSuperuser?: boolean;
};

export function canUseFullPatientActions({
  isPractitionerWorkspace,
  canAccessNursingActions,
  isSuperuser,
}: PatientActionVisibilityOptions) {
  return Boolean(
    isSuperuser || !isPractitionerWorkspace || canAccessNursingActions,
  );
}
